import React from 'react'
import type { FindingCategory, ScanFinding } from '@/lib/apiTypes'
import { findingInCategory } from '@/features/modules/tabs/moduleTabs'

export function categoryFindingBadge(findings: ScanFinding[], category: FindingCategory): React.ReactNode {
  const hits = findings.filter((f) => findingInCategory(f, category))
  if (!hits.length) return <span style={{ color: 'var(--text3)', marginLeft: 4, fontSize: '0.68rem' }}>-</span>
  const hasCritical = hits.some((f) => f.severity === 'critical')
  const hasHigh     = hits.some((f) => f.severity === 'high')
  const cls = hasCritical ? 'badge badge-red' : hasHigh ? 'badge badge-amber' : 'badge badge-neutral'
  return <span className={cls} style={{ marginLeft: 6, fontSize: '0.65rem' }}>{hits.length}</span>
}
